import React from 'react';
import { Map } from 'lucide-react';

export const MapTypeControls = ({ 
  mapType = 'roadmap',
  onMapTypeChange = () => {},
}) => {
  const getButtonStyles = (active) => {
    if (active) return 'bg-blue-500 text-white';
    return 'bg-gray-700 text-gray-400 hover:bg-gray-600 hover:text-white';
  };

  return (
    <div className="flex flex-col space-y-1">
      <button
        onClick={() => onMapTypeChange('roadmap')}
        className={`p-2 rounded-lg flex items-center gap-2 w-full ${getButtonStyles(mapType === 'roadmap')}`}
        title="Road Map"
      >
        <Map className="w-4 h-4" />
        <span className="text-sm">Road</span>
      </button>
      <button
        onClick={() => onMapTypeChange('satellite')}
        className={`p-2 rounded-lg flex items-center gap-2 w-full ${getButtonStyles(mapType === 'satellite')}`}
        title="Satellite"
      >
        <span className="w-4 h-4">🛰️</span>
        <span className="text-sm">Satellite</span>
      </button>
    </div>
  );
};